import React, {useEffect, useState} from 'react';
import {IconButtonMUI, TabItem, Tabs} from '../../../../shared';
import ProjectItems from '../../ProjectItems';
import ButtonMUI from '../../../../shared/ButtonMUI';
import SwitchMUI from '../../../../shared/SwitchMUI';
import {Controller, useForm} from 'react-hook-form';
import SelectComponent from '../../../../shared/SelectComponent';
import * as yup from 'yup';
import {yupResolver} from '@hookform/resolvers/yup';
import {
    getCompanyEmployeeInner,
    getCompanyEmployeeList,
    patchCompanyEmployeeFire,
    patchCompanyEmployeeReturn,
    postCompanyEmployeeInnerEdit
} from '../../../../redux/actions/employee/employeeActions';
import {useDispatch, useSelector} from 'react-redux';
import LoadPanel from '../../LoadPanel';
import Rating from '../../Rating';
import {notifySuccess} from '../../../../helpers/notifySnack';
import {useTranslation} from 'react-i18next';
import {ReactComponent as ToReleaseIcon} from '../../../../assets/icons/to-release.svg';
import {ReactComponent as WorkIcon} from '../../../../assets/icons/tabWork.svg';
import {ReactComponent as CompletedIcon} from '../../../../assets/icons/tabCompleted.svg';
import {ReactComponent as StoppedIcon} from '../../../../assets/icons/tabStoped.svg';
import {ReactComponent as PhoneIcon} from '../../../../assets/icons/phone.svg';
import {ReactComponent as EmailIcon} from '../../../../assets/icons/email.svg';
import {ReactComponent as UseAddIcon} from '../../../../assets/icons/user-add.svg';
import {ReactComponent as MultipleIcon} from '../../../../assets/icons/multiple.svg';
import Avatar from '../../../../assets/images/avatars/avatar-users.png';
import {clearUserRoles, getUserRoles} from '../../../../redux/actions/profile/profileActions';
import './EmployeesInner.scss';
import {
    getProject,
    getProjectMembersList,
    projectMemberRemove
} from '../../../../redux/actions/projects/projectsActions';
import {ReactComponent as DeleteIcon} from '../../../../assets/icons/delete-perticipants.svg';
import {setModal, showConfirmPopup} from '../../../../redux/actions/app/appActions';
import {ROLES} from "../../../../helpers/constants";
import {POPUPS} from "../../../../redux/actions/app/appActionTypes";

const EmployeesInner = ({
                            companyEmployeesInner,
                            companyId,
                            btnLoading,
                            setBtnLoading,
                            project,
                            projectId,
                            handleList,
                            removePermission = false,
                            editPermission = false,
                            readPermission = false,
                            viewProjectPermission = false,
                            fireEmployeePermission = false,
                            returnEmployeePermission = false,
                        }) => {
    const dispatch = useDispatch();
    const employeeId = companyEmployeesInner?.employeeId;
    const {t} = useTranslation();
    const [buttonLoad, setButtonLoad] = useState(false);
    const [buttonRemoveLoad, setButtonRemoveLoad] = useState(false);
    const [selectedRole, setSelectedRole] = useState('');
    const profileMe = useSelector((state) => state.profile.profileMe);
    const isMe = profileMe?.id === companyEmployeesInner?.id;
    const {userRoles} = useSelector((state) => state.profile);

    const permissions = [
        {title: t('EmployeesInner.project_creation'), key: 'project_create'},
        {title: t('EmployeesInner.editing_all_projects'), key: 'project_edit_all'},
        {title: t('EmployeesInner.estimate'), key: 'estimate'},
        {title: t('EmployeesInner.employee_management'), key: 'employee_management'},
        {title: t('EmployeesInner.document_adding'), key: 'document_adding'},
        {title: t('EmployeesInner.drawing_adding'), key: 'drawing_adding'},
        {title: t('EmployeesInner.mailing_sending'), key: 'mailing_send'},
        {title: t('EmployeesInner.adding_photos_videos'), key: 'photo_video_add'},
        {title: t('EmployeesInner.changes_in_participants'), key: 'members_edit'}
    ];

    const [settings, setSettings] = useState({
        document_adding: true,
        drawing_adding: true,
        photo_video_add: true,
        mailing_send: true,
        project_create: true,
        project_edit_all: true,
        members_edit: true,
        employee_management: true,
        estimate: true,
    });

    const disableSelectPermission = [ROLES.HEAD_OF_THE_SALES_DEPARTMENT , ROLES.TECHNICAL_DIRECTOR].includes(profileMe?.role)
    useEffect(() => {
        if (companyEmployeesInner && Object.keys(companyEmployeesInner.permissions).length) {
            setSettings(companyEmployeesInner.permissions);
        }
    }, [companyEmployeesInner.permissions]);

    useEffect(() => {
        if (!userRoles.length) {
            dispatch(getUserRoles('employee'));
        }
        return () => {
            dispatch(clearUserRoles());
        };
    }, [dispatch]);

    const schema = yup.object({
        position: yup.string().required(t('validations.required'))
    });

    const {
        control,
        handleSubmit,
        reset,
        formState: {isSubmitting}
    } = useForm({
        mode: 'all',
        reValidateMode: 'onChange',
        shouldFocusError: true,
        resolver: yupResolver(schema),
        defaultValues: {
            position: ''
        }
    });

    const position = userRoles.map((role) => ({
        id: role.id,
        role: role.role,
        name: role.name
    }));

    const handleFireInner = async () => {
        setBtnLoading(true);
        const response = await dispatch(patchCompanyEmployeeFire(companyId, employeeId));

        if (response.payload?.status === 202) {
            if (project) {
                await Promise.all([
                    dispatch(getProjectMembersList(projectId)),
                    dispatch(getCompanyEmployeeInner(companyId, employeeId))
                ]);
                notifySuccess(t('all.successfully'));
            } else {
                await Promise.all([
                    dispatch(getCompanyEmployeeList(companyId)),
                    dispatch(getCompanyEmployeeInner(companyId, employeeId))
                ]);
                notifySuccess(t('all.successfully'));
            }
            setBtnLoading(false);
        }
    };

    const handleReturnInner = async () => {
        setBtnLoading(true);
        const response = await dispatch(patchCompanyEmployeeReturn(companyId, employeeId));

        if (response.payload?.status === 202) {
            if (project) {
                await Promise.all([
                    dispatch(getProjectMembersList(projectId)),
                    dispatch(getCompanyEmployeeInner(companyId, employeeId))
                ]);
                notifySuccess(t('all.successfully'));
            } else {
                await Promise.all([
                    dispatch(getCompanyEmployeeList(companyId)),
                    dispatch(getCompanyEmployeeInner(companyId, employeeId))
                ]);
                notifySuccess(t('all.successfully'));
            }

            setBtnLoading(false);
        }
    };

    const handleRemoveEmployees = async (employeeId) => {
        setButtonRemoveLoad(true);
        try {
            const response = await dispatch(projectMemberRemove(projectId, employeeId));
            if (response.payload?.status === 204) {
                await Promise.all([dispatch(getProjectMembersList(projectId)), dispatch(getProject(projectId))]);
                handleList();
                notifySuccess(t('all.successfully'));
            }
        } finally {
            setButtonRemoveLoad(false);
        }
    };

    const handleFireInnerRedux = async () => {
        dispatch(
            showConfirmPopup({
                visible: true,
                title: t('participant.fireTitle'),
                text: t('participant.fireText'),
                confirmCallback: () => handleFireInner()
            })
        );
    };

    const handleReturnInnerRedux = async () => {
        dispatch(
            showConfirmPopup({
                visible: true,
                title: t('participant.returnTitle'),
                text: t('participant.returnText'),
                confirmCallback: () => handleReturnInner()
            })
        );
    };

    const handleRemoveEmployeesRedux = async (employeeId) => {
        dispatch(
            showConfirmPopup({
                visible: true,
                title: t('participant.removeTitle'),
                text: t('participant.removeText'),
                confirmCallback: () => handleRemoveEmployees(employeeId)
            })
        );
    };

    useEffect(() => {
        const defaultRole = userRoles.find((role) => role.role === companyEmployeesInner.position);
        if (defaultRole) {
            setSelectedRole(defaultRole.id);
            reset({position: defaultRole.id});
        }
    }, [companyEmployeesInner, userRoles, reset]);

    const onSubmit = async (data) => {
        setButtonLoad(true);
        try {
            const selectedRole = position.find((role) => role.id === data.position);

            if (!selectedRole) {
                throw new Error('Role not found');
            }

            const permissionsData = {
                document_adding: settings.document_adding,
                drawing_adding: settings.drawing_adding,
                employee_management: settings.employee_management,
                estimate: settings.estimate,
                mailing_send: settings.mailing_send,
                members_edit: settings.members_edit,
                photo_video_add: settings.photo_video_add,
                project_create: settings.project_create,
                project_edit_all: settings.project_edit_all,
            };

            const payload = {
                position: selectedRole.role,
                permissions: permissionsData
            };

            const res = await dispatch(postCompanyEmployeeInnerEdit(companyId, employeeId, payload));

            if (res.payload?.status === 202) {
                if (project) {
                    await Promise.all([
                        dispatch(getProjectMembersList(projectId)),
                        dispatch(getCompanyEmployeeInner(companyId, employeeId))
                    ]);
                } else {
                    await Promise.all([
                        dispatch(getCompanyEmployeeList(companyId)),
                        dispatch(getCompanyEmployeeInner(companyId, employeeId))
                    ]);
                }
                notifySuccess(t('all.successfully'));
            }
        } catch (error) {
            console.error('Error updating employee:', error);
        } finally {
            setButtonLoad(false);
        }
    };

    const activeProjects = companyEmployeesInner?.projects?.filter((project) => project.status === 'active');
    const completedProjects = companyEmployeesInner?.projects?.filter((project) => project.status === 'done');
    const pausedProjects = companyEmployeesInner?.projects?.filter((project) => project.status === 'pause');

    const handleSwitchChange = (key) => (event) => {
        setSettings({
            ...settings,
            [key]: event.target.checked
        });
    };

    const openMultiPopup = () => {
        dispatch(setModal(POPUPS.MULTI_EMPLOYEE_POPUP));
    }

    if (!userRoles.length) {
        return <LoadPanel noBg={true} circleSize={50} staticPos={true}/>;
    }


    return (
        <div className='employees-inner'>
            <div className='employees-inner__details'>
                <div className='employees-inner__details-info'>
                    <div className='name'>
                        <div className='avatar'>
                            {companyEmployeesInner.avatar ? (
                                <img src={companyEmployeesInner.avatar} alt={companyEmployeesInner.firstName}/>
                            ) : (
                                <img src={Avatar} alt={companyEmployeesInner.firstName}/>
                            )}

                            {companyEmployeesInner.status === 'active' ? (
                                <div className='status active'/>
                            ) : (
                                <div className='status'/>
                            )}
                        </div>
                        <div className="employees-inner__details-name">
                            {companyEmployeesInner.firstName}
                            {!editPermission && <span>{companyEmployeesInner.positionName}</span>}
                        </div>
                        {editPermission && !project && companyEmployeesInner.status === 'active'   ?  <div className={'employees-inner__details-edit'}>
                            <IconButtonMUI title={t('all.addToProjects')} onClick={openMultiPopup}>
                                <MultipleIcon/>
                            </IconButtonMUI>
                        </div> : null}

                    </div>

                    <div className='employees-inner__details-employees'>
                        <div className='employees-inner__details-contact'>
                            <PhoneIcon/>
                            {companyEmployeesInner.phone ? companyEmployeesInner.phone : '-'}
                        </div>
                        <div className='employees-inner__details-contact'>
                            <EmailIcon/>
                            {companyEmployeesInner.email ? companyEmployeesInner.email : '-'}
                        </div>
                        <div className='employees-inner__details-rating'>
                            <Rating mark={companyEmployeesInner.mark}/>
                            {companyEmployeesInner.mark}/5
                        </div>
                    </div>
                </div>
            </div>

            <form className='employees-inner__form' onSubmit={handleSubmit(onSubmit)}>
                <div className='employees-inner__actions'>
                    {editPermission && (
                        <div className='employees-inner__actions-select'>
                            <Controller
                                name='position'
                                control={control}
                                defaultValue={selectedRole}
                                render={({field}) => (
                                    <SelectComponent
                                        onChange={field.onChange}
                                        onBlur={field.onBlur}
                                        value={position.find((c) => c.id === field.value) || null}
                                        options={position}
                                        label={t('EmployeesInner.role')}
                                        placeholder=''
                                        inputProps={field}
                                        disabled={!editPermission || isMe || disableSelectPermission}
                                    />
                                )}
                            />
                        </div>
                    )}

                    {project && removePermission && !isMe && (
                        <ButtonMUI
                            color='primary'
                            startIcon={<DeleteIcon/>}
                            onClick={() => handleRemoveEmployeesRedux(companyEmployeesInner.employeeId)}
                            loading={buttonRemoveLoad}
                        >
                            {t('EmployeesInner.remove')}
                        </ButtonMUI>
                    )}

                    {companyEmployeesInner.status === 'active' && fireEmployeePermission && !isMe && (
                        <ButtonMUI onClick={handleFireInnerRedux} loading={btnLoading}>
                            <ToReleaseIcon/>
                            {t('EmployeesInner.fire')}
                        </ButtonMUI>
                    )}
                    {companyEmployeesInner.status !== 'active' && returnEmployeePermission && !isMe && (
                        <ButtonMUI onClick={handleReturnInnerRedux} loading={btnLoading}>
                            <UseAddIcon/>
                            {t('EmployeesInner.return')}
                        </ButtonMUI>
                    )}
                </div>
                {readPermission && (
                    <div className='employees-inner__permissions'>
                        <div className='employees-inner__permissions-title'>{t('EmployeesInner.user_permissions')}</div>

                        <div className='employees-inner__permissions-list'>
                            {permissions.map(({title, key}, idx) => (
                                <div key={idx} className='switch'>
                                    <SwitchMUI
                                        color='primary'
                                        value={key}
                                        checked={settings[key]}
                                        onChange={handleSwitchChange(key)}
                                        disabled={!editPermission || isMe}
                                    />
                                    <div className='switch__title'>{title}</div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
                {editPermission && !isMe && (
                    <ButtonMUI loading={buttonLoad || isSubmitting} formAction disabled={!editPermission || buttonLoad}>
                        {t('EmployeesInner.change')}
                    </ButtonMUI>
                )}
            </form>
            {viewProjectPermission && (
                <div className='employees-inner__tabs'>
                    <Tabs defaultIndex='1'>
                        <TabItem
                            label={t('EmployeesInner.tabs.inProgress')}
                            icon={<WorkIcon/>}
                            count={activeProjects.length}
                            index='1'
                        >
                            {activeProjects.length >= 1 ? (
                                <ProjectItems projects={activeProjects}/>
                            ) : (
                                <div className='project-no-items'>{t('EmployeesInner.tabs.noProjects')}</div>
                            )}
                        </TabItem>
                        <TabItem
                            label={t('EmployeesInner.tabs.completed')}
                            icon={<CompletedIcon/>}
                            count={completedProjects.length}
                            index='2'
                        >
                            {completedProjects.length >= 1 ? (
                                <ProjectItems projects={completedProjects}/>
                            ) : (
                                <div className='project-no-items'>{t('EmployeesInner.tabs.noProjects')}</div>
                            )}
                        </TabItem>
                        <TabItem
                            label={t('EmployeesInner.tabs.paused')}
                            icon={<StoppedIcon/>}
                            count={pausedProjects.length}
                            index='3'
                        >
                            {pausedProjects.length >= 1 ? (
                                <ProjectItems projects={pausedProjects}/>
                            ) : (
                                <div className='project-no-items'>{t('EmployeesInner.tabs.noProjects')}</div>
                            )}
                        </TabItem>
                    </Tabs>
                </div>
            )}
        </div>
    );
};

export default EmployeesInner;
